import { Select } from "antd";

import { BusinessAssetType } from "../../types";

const ASSET_TYPE_OPTIONS = [
  {
    label: "Bewegliche Wirtschaftsgüter",
    options: [
      {
        value: BusinessAssetType.MOVABLE_MOTOR_VEHICLES,
        label: "Kraftfahrzeuge",
      },
      {
        value: BusinessAssetType.MOVABLE_OFFICE_EQUIPMENT,
        label: "Büroausstattung",
      },
      { value: BusinessAssetType.MOVABLE_OTHERS, label: "Andere" },
    ],
  },
  {
    label: "Unbewegliche Wirtschaftsgüter",
    options: [
      {
        value: BusinessAssetType.IMMOVABLE,
        label: "Unbewegliche Wirtschaftsgüter",
      },
    ],
  },
  {
    label: "Immaterielle Wirtschaftsgüter",
    options: [
      {
        value: BusinessAssetType.INTANGIBLE,
        label: "Immaterielle Wirtschaftsgüter",
      },
    ],
  },
];

export const BusinessAssetTypeSelect = ({
  id,
  value,
  onChange,
  className,
  invalid,
}: {
  id: string;
  value: BusinessAssetType;
  onChange: (value: BusinessAssetType) => void;
  className?: string;
  invalid?: boolean;
}) => {
  return (
    <Select
      id={id}
      value={value}
      onChange={onChange}
      status={invalid ? "error" : undefined}
      className={className}
      options={ASSET_TYPE_OPTIONS}
      style={{ width: "100%" }}
    />
  );
};
